module.exports = __webpack_public_path__ + "static/media/config2.398c2ed1.jpg";